<script>
import AccountAPI from './../../api/account.js'

import HeaderFive from './../shared/HeaderFive.vue'
import Footer from './../shared/Footer.vue'

export default {
  name: 'ForgotPassword',
  components: {
    Footer,
    HeaderFive
  },
  watch: {
    show_error (new_value, old_value) {
      // Autoclose Error after 5 Seconds
      if (new_value == true) {
        setTimeout(() => {
          this.show_error = false
          this.error_message = ''
        }, 5000)
      }
    }
  },
  data () {
    return {
      show_error: false,
      error_message: '',
      email_address: '',
      submitting: false,
      requested: false
    }
  },
  methods: {
    validateForgotPassword () {
      var error = {
        message: '',
        has_error: 0
      }
      
      // if (this.email_address == '') {
      //   error.message = 'Please enter your Email Address'
      //   error.has_error = 1
      //   return error
      // } else if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.email_address))) {
      //   error.message = 'Please enter a valid Email Address'
      //   error.has_error = 1
      //   return error
      // }

      return error
    },
    forgotPassword () {
      this.show_error = false
      this.error_message = ''

      var validation = this.validateForgotPassword()
      if (validation.has_error) {
        this.show_error = true
        this.error_message = validation.message
        this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
      } else {
        try {
          this.submitting = true
          var forgot_password_request = AccountAPI.forgotPassword(
            this.email_address
          )
          forgot_password_request.then((response) => {
            if (response.status == 'success') {
              this.requested   = true
              this.submitting = false
            }
            else
            {
              this.submitting = false;
               this.show_error = true
              this.error_message = response.error;
              this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
            }
          })
        } catch (error) {
          this.submitting = false
          this.show_error = true
          this.error_message = error
          this.$refs['title'].scrollIntoView({ behavior: 'smooth' })
        }
      }
    },
  }
}
</script>

<template>
  <div class="page register-page">
    <HeaderFive />

      <!-- BREADCRUMB AREA START -->
    <div class="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-image" data-bg="img/bg/9.jpg">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                        <div class="section-title-area ltn__section-title-2">
                           
                            <h1 class="section-title white-color">Account</h1>
                        </div>
                        <div class="ltn__breadcrumb-list">
                            <ul>
                                <li><router-link to="/">Home</router-link></li>
                                <li>Forgot Password</li>
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="anchor" ref="title" ></div>
    </div>
    <!-- BREADCRUMB AREA END -->

    <!-- LOGIN AREA START (Register) -->
    <div class="ltn__login-area pb-110" >
        <div class="container" v-if="!requested">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1  class="section-title">Reset Password</h1>
                        <p>Enter the email/mobile no. associated to your account and we'll send an email with instructions to reset your password</p>
                    </div>
                     <h5 v-if="show_error">{{ error_message }}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="ltn__form-box contact-form-box">
                          
                            <input type="text" name="email" v-model="email_address" placeholder="Email Address/Mobile No. *">
                            <div class="btn-wrapper">
                                <button @click="forgotPassword" :disabled="submitting" class="theme-btn-1 btn reverse-color btn-block" type="submit">{{ submitting ? 'PROCESSING' : 'SUBMIT' }}</button>
                            </div>
                        </div>
                        <div class="by-agree text-center">
                             <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container" v-if="requested">
            <div class="row">
                <div class="col-lg-12">
                    <div class="section-title-area text-center">
                        <h1 ref="title" class="section-title">Check your mail or mobile number</h1>
                        <p>Please check your email or mobile number<br>for the temporary password reset link.</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 offset-lg-3">
                    <div class="account-login-inner">
                        <div class="by-agree text-center">
                            <div class="go-to-btn mt-50">
                                <router-link to="/login">ALREADY HAVE AN ACCOUNT ? LOGIN HERE</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- LOGIN AREA END -->

    <!-- FEATURE AREA START ( Feature - 3) -->
    <div class="ltn__feature-area before-bg-bottom-2 mb--30--- plr--5">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ltn__feature-item-box-wrap ltn__border-between-column white-bg">
                        <div class="row">
                            <div class="col-xl-3 col-md-6 col-12">
                                <div class="ltn__feature-item ltn__feature-item-8">
                                    <div class="ltn__feature-icon">
                                        <img src="/static/img/icons/icon-img/11.png" alt="#">
                                    </div>
                                    <div class="ltn__feature-info">
                                        <h4>Curated Products</h4>
                                        <p>Provide Curated Products for
                                            all product over $100</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 col-12">
                                <div class="ltn__feature-item ltn__feature-item-8">
                                    <div class="ltn__feature-icon">
                                        <img src="/static/img/icons/icon-img/12.png" alt="#">
                                    </div>
                                    <div class="ltn__feature-info">
                                        <h4>Handmade</h4>
                                        <p>We ensure the product quality
                                            that is our main goal</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 col-12">
                                <div class="ltn__feature-item ltn__feature-item-8">
                                    <div class="ltn__feature-icon">
                                        <img src="/static/img/icons/icon-img/13.png" alt="#">
                                    </div>
                                    <div class="ltn__feature-info">
                                        <h4>Natural Food</h4>
                                        <p>Return product within 3 days
                                            for any product you buy</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-3 col-md-6 col-12">
                                <div class="ltn__feature-item ltn__feature-item-8">
                                    <div class="ltn__feature-icon">
                                        <img src="/static/img/icons/icon-img/14.png" alt="#">
                                    </div>
                                    <div class="ltn__feature-info">
                                        <h4>Free home delivery</h4>
                                        <p>We ensure the product quality
                                            that you can trust easily</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- FEATURE AREA END -->

    <Footer />
  </div>
</template>
<style>
.ltn__login-area h5 {
    background-color: var(--section-bg-1);
    padding: 20px 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ForgotPassword.vue